/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, contingent: NonNullable<unknown> }} Dropdailyremaining2Inputs */

const en_dropdailyremaining2 = /** @type {(inputs: Dropdailyremaining2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} of ${i?.contingent} left`)
};

const de_dropdailyremaining2 = /** @type {(inputs: Dropdailyremaining2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.remaining} von ${i?.contingent}`)
};

/**
* | output |
* | --- |
* | "{remaining} of {contingent} left" |
*
* @param {Dropdailyremaining2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyremaining2 = /** @type {((inputs: Dropdailyremaining2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyremaining2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyremaining2(inputs)
	return de_dropdailyremaining2(inputs)
});
export { dropdailyremaining2 as "dropDailyRemaining" }